<div class="form-group">
  <label for="name">Nom du groupe</label>
  <input id="name" type="text" placeholder="" [formControl]="name" maxlength="200" />
  <span class="info info-error" [hidden]="name.valid || name.pristine || !name.errors.required">Ce champ est requis</span>
</div>